import { render, staticRenderFns } from "./ResumeManager.vue?vue&type=template&id=552b3b55&scoped=true&"
import script from "./ResumeManager.vue?vue&type=script&lang=ts&"
export * from "./ResumeManager.vue?vue&type=script&lang=ts&"
import style0 from "./ResumeManager.vue?vue&type=style&index=0&id=552b3b55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552b3b55",
  null
  
)

export default component.exports